<template>
  <div class="word-item">
    <div class="item" @click.stop="jumpDetail">
      <div class="title">
        <span class="hot" v-if="data.label_name">{{ data.label_name }}</span>
        <span>{{ data.title }}</span>
      </div>
      <div class="item-info">
        <div class="info-item author">作者：{{ data.author_name }}</div>
        <div class="info-item like">{{ data.useful }}人觉得有用</div>
        <div class="info-item copy" v-if="copy" ref="copy" @click.stop="">
          <span class="iconfont icon-fuzhi"></span><span>引用</span>
        </div>
      </div>
      <div class="flex-box">
        <div class="flex-1">
          <div class="info">
            <div class="rich-text" v-html="data.info"></div>
          </div>
          <div class="bottom">
            <span>查看次数：{{ data.num || 0 }}</span>
            <span class="line"></span>
            <span>关键词：</span>
            <span class="keyword">{{ data.keyword1 || '' }}</span>
            <span class="keyword">{{ data.keyword2 || '' }}</span>
            <span class="keyword">{{ data.keyword3 || '' }}</span>
          </div>
        </div>
        <img v-if="data.pics" class="image" :src="data.pics" />
      </div>
      <div class="btn-content">
        <div class="btn-item collect" @click.stop="bindCollect">
          <span
            class="iconfont icon-shixinxingxing"
            :class="{ active: data.is_save === 0 }"
          ></span>
          <span>{{ data.is_save === 0 ? '已收藏' : '收藏' }}</span>
          <span class="like-count">{{ data.save_num || 0 }}</span>
        </div>
        <div class="btn-item like" @click.stop="bindUseful">
          <span
            class="iconfont icon-dianzan_kuai"
            :class="{ active: data.is_useful === 1 }"
          ></span>
          <span>有用</span>
          <span class="like-count">{{ data.useful || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        {
        }
      }
    },
    copy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clipboard: null,
      detailUrl: {
        text: 'https://member3t.gymcity.com.cn/#/fatcamp/knowledge-base/words-detail',
        pro: 'https://member3.gymcity.com.cn/#/fatcamp/knowledge-base/words-detail'
      }
    }
  },
  computed: {
    /* filterText() {
      let res = this.data.info;
      res = res.replace(/<\/+.+?>/g, "\n");
      res = res.replace(/<\/?.+?>/g, "");
      return res;
    }, */
  },
  mounted() {
    if (this.copy) {
      this.clipboard = new Clipboard(this.$refs.copy, {
        // 点击copy按钮，直接通过text直接返回复印的内容
        text: () => {
          return this.filterText(this.data.info)
        }
      })
      this.clipboard.on('success', () => {
        this.$toast('复制成功')
        this.setTypeInc()
        //this.clipboard.destroy();
      })
      this.clipboard.on('error', () => {
        this.$toast('复制失败，请手动复制')
      })
    }
  },
  methods: {
    jumpDetail() {
      this.$router.push({
        path: '/fatcamp/knowledge-base/OA-detail',
        query: {
          id: this.data.id
        }
      })
    },
    setTypeInc() {
      let params = {
        tid: this.data.id
      }
      this.$http
        .getApp('member/StorageLogin/setTypeInc', params)
        .then((res) => {
          this.data.num += 1
        })
        .catch((err) => {
          console.log(err)
          this.$toast('异常错误')
        })
    },
    /*  */
    bindUseful() {
      let params = {
        data_id: this.data.id,
        opt: this.data.is_useful ? 0 : 1
      }
      this.$http
        .getApp('member/StorageLogin/setUseful', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.is_useful = this.data.is_useful ? 0 : 1
            if (!this.data.is_useful) {
              this.data.useful--
            } else {
              this.data.useful++
            }
            this.data.useful = this.data.useful < 0 ? 0 : this.data.useful
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    jumpDetail() {
      this.$router.push({
        path: '/fatcamp/knowledge-base/words-detail',
        query: {
          id: this.data.id
        }
      })
    },
    filterText(str) {
      str = str.replace(/<\/+.+?>/g, '\n')
      str = str.replace(/<\/?.+?>/g, '')
      str = str.replace(/&nbsp;/g, ' ')
      return str
    },
    setTypeInc() {
      let params = {
        tid: this.data.id
      }
      this.$http
        .getApp('member/StorageLogin/setTypeInc', params)
        .then((res) => {
          console.log(res)
          res = res.data
          if (res.code == 200) {
            this.data.num += 1
          } else {
            this.$toast(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //点击有用
    bindLike() {
      let isCollect = this.data.is_like === 0
      if (isCollect) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '确认取消点赞?'
          })
          .then(() => {
            // on confirm
            this.likeArticle()
          })
          .catch(() => {
            // on cancel
          })
        return
      }
      this.likeArticle()
    },
    likeArticle() {
      let params = {
        tid: this.data.id,
        type_0: this.data.type_id,
        type: this.data.is_save === 0 ? 2 : 1
      }
      this.$http
        .postApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.is_save = this.data.is_save === 0 ? 1 : 0
            if (this.data.is_save === 0) {
              this.$toast('点赞成功')
            } else {
              this.$toast('取消点赞')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //点击收藏
    bindCollect() {
      let isCollect = this.data.is_save === 0
      if (isCollect) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '确认取消收藏?'
          })
          .then(() => {
            // on confirm
            this.collectArticle()
          })
          .catch(() => {
            // on cancel
          })
        return
      }
      this.collectArticle()
    },
    collectArticle() {
      let params = {
        tid: this.data.id,
        type_0: this.data.type_id,
        type: this.data.is_save === 0 ? 2 : 1
      }
      this.$http
        .postApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.is_save = this.data.is_save === 0 ? 1 : 0
            if (this.data.is_save === 0) {
              this.$toast('收藏成功')
              this.data.save_num++
            } else {
              this.data.save_num =
                --this.data.save_num < 0 ? 0 : this.data.save_num
              this.$toast('取消收藏')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.word-item {
  width: 100vw;
  padding: 0vw 4.3vw;
  box-sizing: border-box;
}
.item {
  background-color: #ffffff;
  border-radius: 2.7vw;
  padding: 3.7vw 4.3vw;
  box-sizing: border-box;
  text-align: left;
  margin: 2.7vw 0vw;
}

.title {
  line-height: 26px;
  font-family: PingFangSC-Medium;
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin-bottom: 2.7vw;
}
.info {
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  line-height: 5.9vw;
  max-height: 20vw;
  min-height: 5.9vw;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 2.7vw;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.rich-text {
  height: auto;
}
.flex-box {
  display: flex;
  align-items: center;
}
.flex-box .flex-1 {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  margin-right: 2vw;
}
.bottom {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
.bottom .line {
  display: inline-block;
  height: 2.1vw;
  border-right: solid 0.3vw #979797;
  margin: 0vw 2.4vw;
}
.bottom .keyword {
  font-family: PingFangSC-Medium;
  font-size: 3.2vw;
  color: #2882e9;
  margin-right: 2.7vw;
}
.item .image {
  width: 60px;
  height: 60px;
  border-radius: 1.1vw;
  overflow: hidden;
}
.hot {
  display: inline-block;
  vertical-align: 10%;
  line-height: 16px;
  box-sizing: border-box;
  padding: 0px 8px;
  height: 16px;
  background: #f04646;
  border-radius: 4px;
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  margin-right: 5px;
}
.item-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 13px;
}
.item-info .author,
.item-info .like {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 17px;
}
.item-info .copy {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2882e9;
  line-height: 17px;
}
.item-info .copy .iconfont {
  margin-right: 6px;
}
.item-info .info-item {
  overflow: hidden;
  position: relative;
  padding: 0px 12px;
}
.item-info .author {
  max-width: 45%;
}
.item-info .info-item::after {
  content: '';
  position: absolute;
  width: 1px;
  height: 8px;
  background-color: #979797;
  top: 50%;
  right: 0%;
  transform: translate(0%, -50%);
}
.item-info .info-item:first-child {
  padding-left: 0px;
}
.item-info .info-item:last-child {
  padding-right: 0px;
}
.item-info .info-item:last-child::after {
  display: none;
}
.btn-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
}
.btn-content .btn-item {
  width: 150px;
  height: 32px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7e7e7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 18px;
}
.btn-item .iconfont {
  color: #ccc;
  font-size: 17px;
  margin-right: 10px;
}
.btn-item .like-count {
  margin-left: 10px;
}
.btn-content .like .active {
  color: #2882e9;
}
.btn-content .collect .active {
  color: #f7b500;
}
</style>
